namespace RedBullMOBILE360.SenderName {
    export interface SenderNameRow {
        SenderId?: number;
        Name?: string;
    }

    export namespace SenderNameRow {
        export const idProperty = 'SenderId';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'SenderName.SenderName';
        export const lookupKey = 'SenderName.SenderName';

        export function getLookup(): Q.Lookup<SenderNameRow> {
            return Q.getLookup<SenderNameRow>('SenderName.SenderName');
        }
        export const deletePermission = null;
        export const insertPermission = null;
        export const readPermission = '';
        export const updatePermission = null;

        export declare const enum Fields {
            SenderId = "SenderId",
            Name = "Name"
        }
    }
}
